import React, { useState } from "react";
import AppHeader from "../../../components/Header/Header";
import AppLayout from "../../../components/layout";
import BannerSection from "../../../components/BannerSection";
import BreadcrumbNav from "../../../components/BreadcrumbNav";

import banner from "../../../assets/prepar_curs.jpg";

import enfermagemImg from "../../../assets/cursos/enfermagem.jpeg";
import gestaoImg from "../../../assets/cursos/gestao.jpg";
import engenhariaImg from "../../../assets/cursos/engenharia.jpg";
import sociaisImg from "../../../assets/cursos/sociais.jpg";
import inglesImg from "../../../assets/cursos/inglesImg.jpeg";


const caminho = [
  { label: "Home", href: "/", icon: "bi bi-house-door" },
  { label: "Portal do Estudante" },
  { label: "Cursos Online" },
];

const cursos = [
  {
    id: 1,
    title: "Boas Práticas em Laboratório Clínico",
    badge: "Saúde",
    image: enfermagemImg,
    description:
      "Cursos presencial e online, focado em boas práticas laboratoriais para profissionais de saúde.",
    duration: "3 Semansas",
    price_inscription: "5.000 Kz",
    format: "Presencial - Online",
    price: "40.000 Kz",
    location: "Talatona - Estrada Lar do Patriota",
    benefits: [
      "Material incluído",
      "Certificado",
      "Professores especializados",
    ],
  },
  {
    id: 2,
    title: "Curso de Hematologia",
    badge: "Saúde",
    image: gestaoImg,
    description:
      "Curso online intensivo sobre hematologia, ideal para profissionais de saúde e estudantes interessados na área.",
    duration: "3 Semanas",
    price_inscription: "5.000 Kz",
    format: "Online",
    price: "40.000 Kz",
    location: "Talatona, Lar do Patriota",
    benefits: ["Aulas gravadas", "Suporte online", "Certificado"],
  },
  {
    id: 3,
    title: "Curso de Parasitologia",
    badge: "Saúde",
    image: engenhariaImg,
    description:
      "Curso completo sobre parasitologia, ideal para profissionais de saúde e estudantes interessados na área.",
    duration: "3 semanas",
    price_inscription: "5.000 Kz",
    format: "Presencial",
    price: "40.000 Kz",
    location: "Talatona, Lar do Patriota",
    benefits: ["Material incluído", "Professores especializados", "Certificado"],
  },
  {
    id: 4,
    title: "Curso de Exame de Urina, Widal e VHS",
    badge: "Saúde",
    image: sociaisImg,
    description:
      "Curso prático sobre exame de urina, Widal e VHS, ideal para profissionais de saúde e estudantes interessados na área.",
    duration: "3 semanas",
    price_inscription: "5.000 Kz",
    format: "Híbrido",
    price: "40.000 Kz",
    location: "Talatona, Lar do Patriota",
    benefits: ["Material digital", "Aulas presenciais", "Certificado"],
  },
  {
    id: 4,
    title: "Curso de Inglês",
    badge: "Idiomas",
    image: inglesImg,
    description:
      "Curso de inglês online, ideal para estudantes e profissionais que desejam melhorar suas habilidades no idioma.",
    duration: "1 ano e 2 meses. Segunda a sexta-feira",
    price_inscription: "5.000 Kz",
    categoria: "Beginner, Intermediate, Advanced",
    format: "Manhã, Tarde e Noite",
    price: "20.000 Kz",
    location: "Talatona, Lar do patriota",
    benefits: ["Material digital", "Aulas presenciais", "Certificado"],
  },
];

const CursosOnline = () => {

  const [selected, setSelected] = useState(null);

  return (
    <div>

      <header id="header">
        <AppHeader />
      </header>

      <BannerSection
        title="Cursos Online"
        subtitle="Cursos na palma da sua mão"
        description="Os nossos cursos online oferecem flexibilidade e qualidade para sua preparação."
        backgroundImage={banner}
        backgroundId="instituition-Banner"
      />

      <BreadcrumbNav items={caminho} />

      <section
        className="courses section py-5"
        style={{ backgroundColor: "#faf9ff" }}
      >
        <div className="container">

          {/* HEADER */}
          <div className="text-center mb-5">
            <span
              className="badge text-uppercase mb-4"
              style={{
                backgroundColor: "#A8D973",
                color: "white",
                boxShadow: "0px 0px 10px #A8D973",
                borderRadius: "12px",
              }}
            >
              Formação Acelerada
            </span>

            <h2 className="display-5 fw-bold mb-3">
              Cursos de Curta Duração
            </h2>

            <p
              className="lead text-muted mx-auto"
              style={{ maxWidth: "650px" }}
            >
              Capacitação intensiva para impulsionar sua carreira
            </p>
          </div>

          <div className="row g-5">

            {/* DETALHE DO CURSO */}
            <div className="col-lg-6">
              <div
                className="bg-white p-4 rounded-4 shadow-sm"
                style={{ minHeight: "500px" }}
              >
                {selected ? (
                  <>
                    <img
                      src={selected.image}
                      alt={selected.title}
                      className="img-fluid rounded mb-3"
                      style={{ width: "100%", height: "220px", objectFit: "cover" }}
                    />

                    <h3 className="fw-bold">{selected.title}</h3>

                    <span
                      className="badge mb-3"
                      style={{ backgroundColor: "#A8D973" }}
                    >
                      {selected.badge}
                    </span>

                    <p className="text-muted">{selected.description}</p>

                    <div className="row mb-4">
                      <div className="col-3">
                        <small className="text-muted">Duração</small>
                        <strong className="d-block">{selected.duration}</strong>
                      </div>

                      <div className="col-4">
                        <small className="text-muted">Formato</small>
                        <strong className="d-block">{selected.format}</strong>
                      </div>

                      <div className="col-4">
                        <small className="text-muted">Preço da Inscrição</small>
                        <strong className="text-success d-block">
                          {selected.price_inscription}
                        </strong>
                      </div>

                      <div className="col-4">
                        <small className="text-muted">Preço</small>
                        <strong className="text-success d-block">
                          {selected.price}
                        </strong>
                      </div>

                      <div className="col-4">
                        <small className="text-muted">Categoria</small>
                        <strong className="text-success d-block">
                          {selected.categoria ? selected.categoria : "Sem categoria"}
                        </strong>
                      </div>
                   
                        
                    </div>

                    <h6 className="fw-bold">Benefícios</h6>

                    <ul>
                      {selected.benefits.map((b, i) => (
                        <li key={i}>{b}</li>
                      ))}
                    </ul>

                    <p>
                      <strong>Local:</strong> {selected.location}
                    </p>

                    <a
                      href="https://portalonline.icsgisabelinha.com/CursosPreparatorio/Inscricao/Index"
                      className="btn btn-lg rounded-pill px-4 mt-3"
                      style={{
                        backgroundColor: "#A8D973",
                        color: "white",
                      }}
                    >
                      Inscrever-se agora
                    </a>
                  </>
                ) : (
                  <div class="text-center text-muted py-5">
                      <i class="bi bi-arrow-up-circle fs-1 mb-3 d-block text-success"></i>
                      <p class="mb-2">Selecione um curso ao lado para ver mais detalhes</p>
                      <small class="text-muted">Informações completas sobre benefícios, requisitos e investimento</small>
                  </div>
                )}
              </div>
            </div>

            {/* LISTA DE CURSOS */}
            <div className="col-lg-6">
              <div className="row g-4">

                {cursos.map((curso) => (
                  <div key={curso.id} className="col-md-6">

                    <div
                      className="card h-100 border-0 shadow-sm rounded-4"
                      style={{ cursor: "pointer" }}
                      onClick={() => setSelected(curso)}
                    >

                      <img
                        src={curso.image}
                        alt={curso.title}
                        className="card-img-top"
                        style={{
                          height: "160px",
                          objectFit: "cover",
                        }}
                      />

                      <div className="card-body p-4">

                        <div className="d-flex justify-content-between mb-2">

                          <span
                            className="badge"
                            style={{ backgroundColor: "#A8D973" }}
                          >
                            {curso.badge}
                          </span>

                          <small className="text-muted">
                            {curso.format}
                          </small>

                        </div>

                        <h5 className="fw-bold">{curso.title}</h5>

                        <p className="text-muted small">
                          {curso.description}
                        </p>

                        <div className="d-flex justify-content-between align-items-center mt-3">

                          <strong
                            style={{
                              color: "#A8D973",
                              fontSize: "1.1rem",
                            }}
                          >
                            {curso.price}
                          </strong>

                          <button
                            className="btn btn-sm rounded-pill px-3"
                            style={{
                              backgroundColor: "#A8D973",
                              color: "white",
                            }}
                          >
                            Ver detalhes
                          </button>

                        </div>

                      </div>

                    </div>

                  </div>
                ))}

              </div>
            </div>

          </div>
        </div>
      </section>

      <AppLayout />

    </div>
  );
};

export default CursosOnline;